import { useCallback, useRef } from 'react';

export const GRACE_PERIOD = 2000;

export function useNetworkGracePeriod() {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clearGraceTimeout = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  const setGraceTimeout = useCallback(
    (callback: () => void, delay = GRACE_PERIOD) => {
      clearGraceTimeout();
      timeoutRef.current = setTimeout(callback, delay);
    },
    [clearGraceTimeout],
  );

  return {
    clearGraceTimeout,
    setGraceTimeout,
  };
}
